<div class="dialog-container">
	<i class="fa fa-exclamation-triangle fa-5x" aria-hidden="true"></i>
	<h3 class="dialog-title">{{ dialogConstants.updateDetails }}</h3>
	<p class="dialog-message">{{ data.message || dialogConstants.message }}</p>

	<div class="dialog-actions">
		<button mat-button class="btn-cancel" (click)="onNoClick()">
			{{ dialogConstants.btnNo }}
		</button>
		<button mat-button class="btn-yes" (click)="onYesClick()">
			{{ dialogConstants.btnYes }}
		</button>
	</div>
</div>
